import api from './axios'

/**
 * End-User Portal API
 */
export const endUserApi = {
    /**
     * Send verification code to email
     */
    sendVerificationCode: async (email, language = 'en') => {
        const response = await api.post('/end-users/send-code', {
            email,
            language,
        })
        return response
    },

    /**
     * Verify the code
     */
    verifyCode: async (email, code) => {
        const response = await api.post('/end-users/verify-code', {
            email,
            code,
        })
        return response
    },

    /**
     * Register new end user (requires verified code)
     */
    register: async (fullName, email, password, verificationCode, phone = null) => {
        const response = await api.post('/end-users/register', {
            full_name: fullName,
            email,
            password,
            verification_code: verificationCode,
            phone,
        })
        return response
    },

    /**
     * Login end user
     */
    login: async (email, password, formId = null) => {
        const response = await api.post('/end-users/login', {
            email,
            password,
            form_id: formId,
        })
        return response
    },

    /**
     * Get current user profile
     */
    me: async () => {
        const response = await api.get('/end-users/me')
        return response
    },

    /**
     * Update profile
     */
    updateProfile: async (data) => {
        const response = await api.put('/end-users/profile', data)
        return response
    },

    /**
     * Get accessible forms
     */
    getAccessibleForms: async () => {
        const response = await api.get('/end-users/forms')
        return response
    },

    /**
     * Get my submissions
     */
    getMySubmissions: async () => {
        const response = await api.get('/end-users/submissions')
        return response
    },

    /**
     * Get submission detail with approvals
     */
    getSubmissionDetail: async (id) => {
        const response = await api.get(`/end-users/submissions/${id}`)
        return response
    },

    /**
     * Change password
     */
    changePassword: async (data) => {
        const response = await api.put('/end-users/password', data)
        return response
    },
}

/**
 * Approval Workflow API
 */
export const approvalApi = {
    /**
     * Get pending approvals for department
     */
    getPendingApprovals: async (departmentId = null) => {
        const url = departmentId
            ? `/approvals/pending?department_id=${departmentId}`
            : '/approvals/pending'
        const response = await api.get(url)
        return response
    },

    /**
     * Approve a submission
     */
    approve: async (approvalId, note = null) => {
        const response = await api.post(`/approvals/${approvalId}/approve`, { note })
        return response
    },

    /**
     * Deny a submission
     */
    deny: async (approvalId, note = null) => {
        const response = await api.post(`/approvals/${approvalId}/deny`, { note })
        return response
    },

    /**
     * Add note to approval
     */
    addNote: async (approvalId, note) => {
        const response = await api.post(`/approvals/${approvalId}/note`, { note })
        return response
    },

    /**
     * Get all approvals for a submission
     */
    getBySubmission: async (submissionId) => {
        const response = await api.get(`/approvals/submission/${submissionId}`)
        return response
    },

    /**
     * Get approval timeline
     */
    getTimeline: async (submissionId) => {
        const response = await api.get(`/approvals/timeline/${submissionId}`)
        return response
    },
}

export default { endUserApi, approvalApi }
